var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 22.25H8.73998C3.82998 22.25 1.72998 20.15 1.72998 15.24V15.11C1.72998 10.67 3.47998 8.53003 7.39998 8.16003C7.79998 8.13003 8.17998 8.43003 8.21998 8.84003C8.25998 9.25003 7.95998 9.62003 7.53998 9.66003C4.39998 9.95003 3.22998 11.43 3.22998 15.12V15.25C3.22998 19.32 4.66998 20.76 8.73998 20.76H15.26C19.33 20.76 20.77 19.32 20.77 15.25V15.12C20.77 11.41 19.58 9.93003 16.38 9.66003C15.97 9.62003 15.66 9.26003 15.7 8.85003C15.74 8.44003 16.09 8.13003 16.51 8.17003C20.49 8.51003 22.27 10.66 22.27 15.13V15.26C22.27 20.15 20.17 22.25 15.26 22.25Z",
    fill: "#8D5245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.63C11.59 15.63 11.25 15.29 11.25 14.88V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V14.88C12.75 15.3 12.41 15.63 12 15.63Z",
    fill: "#8D5245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.7501C11.8101 16.7501 11.6201 16.6801 11.4701 16.5301L8.12009 13.1801C7.83009 12.8901 7.83009 12.4101 8.12009 12.1201C8.41009 11.8301 8.89009 11.8301 9.18009 12.1201L12.0001 14.9401L14.8201 12.1201C15.1101 11.8301 15.5901 11.8301 15.8801 12.1201C16.1701 12.4101 16.1701 12.8901 15.8801 13.1801L12.5301 16.5301C12.3801 16.6801 12.1901 16.7501 12.0001 16.7501Z",
    fill: "#8D5245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.063b96e0c258d91b47e7cec062798df0.svg";
export { ForwardRef as ReactComponent };